import { ReactNode } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

interface AppLayoutProps {
  children: ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className="flex">
        <Sidebar />

        <div className="ml-0 md:ml-[240px] pt-[90px] md:pt-[20px] px-3 md:pl-16 pb-10">
          {children}
        </div>
      </div>
    </>
  );
};

export default AppLayout;
